import { Table, Button, TableColumn } from 'common/components';
import { FileText, SquarePlay } from 'lucide-react';
import { FormatedCallHistoryItem } from 'pages/AgentCommandCenter/AgentCommandCenter.utils';
import { CallInfo } from 'types/agentCommandCenter.type';

import styles from './CallHistory.module.scss';

type CallHistoryProps = {
    calls: FormatedCallHistoryItem[];
    onViewTranscript: (callId: string, callInfo: CallInfo) => void;
    onListenRecording: (callId: string, callInfo: CallInfo) => void;
    isLoading: boolean;
};

export const CallHistory = ({ calls, onViewTranscript, onListenRecording, isLoading }: CallHistoryProps) => {
    const columns: TableColumn<FormatedCallHistoryItem>[] = [
        {
            key: 'callDate',
            title: 'Date',
            dataIndex: 'callDate',
        },
        {
            key: 'contactName',
            title: 'Contact Name',
            dataIndex: 'contactName',
        },
        {
            key: 'phoneNumber',
            title: 'Phone Number',
            dataIndex: 'phoneNumber',
        },
        {
            key: 'timeOfCall',
            title: 'Time of Call',
            dataIndex: 'timeOfCall',
        },
        {
            key: 'duration',
            title: 'Duration',
            dataIndex: 'duration',
        },
        {
            key: 'transcript',
            title: 'Transcript',
            align: 'center',
            render: (_, record) => (
                <Button
                    variant='ghost'
                    size='sm'
                    iconOnly
                    isRounded
                    icon={FileText}
                    onClick={() => onViewTranscript && onViewTranscript(record.callId, record)}
                    title='View transcript'
                />
            ),
        },
        {
            key: 'recording',
            title: 'Recording',
            align: 'center',
            render: (_, record) => (
                <Button
                    variant='ghost'
                    size='sm'
                    iconOnly
                    isRounded
                    icon={SquarePlay}
                    onClick={() => onListenRecording && onListenRecording(record.callId, record)}
                    title='Listen to recording'
                />
            ),
        },
        {
            key: 'actionTaken',
            title: 'Action Taken',
            dataIndex: 'actionTaken',
        },
    ];

    return (
        <div className={styles.callHistorySection}>
            <h2>Call History</h2>
            <Table
                data={calls}
                columns={columns}
                emptyText='No call history available'
                rowKey='callId'
                size='medium'
                variant='secondary'
                isLoading={isLoading}
            />
        </div>
    );
};
